import React from "react";
import { Avatar, FormControl, Grid, TextField, Typography } from "@material-ui/core";
import Uploader from "../../../../components/Uploader/uploader";

class AvailableFAQConnector extends React.Component {
  renderFallbackIntentSetup = () => {
    if (!this.props.shouldRenderFallbackIntentFields) {
      return null;
    }

    return (
      <React.Fragment>
        <Grid item xs={12}>
          <TextField
            id="fallback-intent-plain-text-response"
            label="Plain Text Error Response"
            value={this.props.state[this.props.connection.connectionName]["values"].fallbackIntentPlainTextResponse}
            onChange={event => this.props.handleFieldChange("fallbackIntentPlainTextResponse", event.target.value)}
            variant="outlined"
            style={{ width: "100%" }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="fallback-intent-rich-card-response"
            label="Rich (HTML) Card Error Response"
            value={this.props.state[this.props.connection.connectionName]["values"].fallbackIntentRichCardResponse}
            onChange={event => this.props.handleFieldChange("fallbackIntentRichCardResponse", event.target.value)}
            variant="outlined"
            multiline={true}
            rows="4"
            style={{ width: "100%" }}
          />
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    return (
      <React.Fragment>
        <FormControl className={this.props.classes.inputContainer}>
          {/*<BootstrapInput*/}
          {/*  id="faq-connection-name"*/}
          {/*  autoFocus*/}
          {/*  value={this.props.state[this.props.connection.connectionName]["values"].faq_name}*/}
          {/*  onChange={event => this.props.handleFieldChange("faq_name", event.target.value)}*/}
          {/*/>*/}

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="faq-connection-name"
                label="Connector name"
                // className={classes.textField}
                value={this.props.state[this.props.connection.connectionName]["values"].faq_name}
                onChange={event => this.props.handleFieldChange("faq_name", event.target.value)}
                // margin="normal"
                variant="outlined"
                style={{ width: "100%" }}
              />
            </Grid>

            {this.renderFallbackIntentSetup()}

            {this.props.state[this.props.connection.connectionName]["errors"].faq_name && (
              <Grid item xs={12}>
                <Typography className={this.props.classes.fieldError} variant="body2">
                  {this.props.state[this.props.connection.connectionName]["errors"].faq_name}
                </Typography>
              </Grid>
            )}
          </Grid>
        </FormControl>

        {/*<div className={this.props.classes.avatarAndUploaderContainer}>*/}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Avatar
              alt="User profile image"
              src={this.props.getConnectorImage()}
              className={this.props.classes.bigAvatar}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Uploader
              type="image-uploader"
              contentType="application/octet-stream"
              accepts="image/*"
              updateConnectorImage={this.props.updateConnectorImage}
              administrator={this.props.administrator}
            />
          </Grid>
        </Grid>
        {/*</div>*/}
      </React.Fragment>
    );
  }
}

export default AvailableFAQConnector;
